import { schema } from 'normalizr';

const questionSchema = new schema.Entity('questions');

export default {
  questionSchema,
};
